import React from "react";
import { Link } from "react-router-dom";

const ResetPasswordConfirm = () => {
  return (
    <div className="password-page">
      <div className="background-wrapper creamy-cement" />
      <h2>
        An email has been sent to your mailbox with a link to reset your
        password
      </h2>
      <div className="center-box">
        <div>
          <p>The link will expire in 1 hour.</p>

          <Link to="/">
            <button className="btn btn-default w-100">Go Home</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordConfirm;
